/**
 * GraphQL query strings for authentication
 * Extracted for use in E2E environments without Apollo Client dependencies
 */

export const refreshTokenQuery = `
  mutation authsvsRefreshToken {
    authsvsRefreshToken {
      __typename
      accessToken
      sessionType
      expiresAt
      userId
    }
  }`
